/**
 * Candidate Media (Media Gallery) role actions.
 *
 * Named `candidate_media*` rather than `media_gallery*` deliberately: the codes name the SCOPE
 * (a candidate's media), not the UI that happens to render it, matching the `vesr_media` /
 * `vesr_media_upload` precedent. A screen can be renamed; the resource cannot.
 *
 * ⚠️ NOT YET SEEDED BACKEND-SIDE. A frontend code only takes effect once an `Action` row exists
 * in api.core, is granted to the role, AND the user re-logs in (action claims are baked into the
 * JWT at mint time). The full ordering — add to `ActionKeys.cs`, manually dispatch
 * `ci-api.core.yml --ref dev` because ActionKeys.cs is watched by no image-building workflow,
 * roll, hand-grant to `Party Admin` and `Candidate` (PermissionBootstrapHostedService grants only
 * to Super Admin), then have users re-log — is in the module plan. Reversed, the gated endpoint
 * returns 403 to everyone including Super Admin.
 *
 * Until then the sidebar entry is gated on `VOTER_INTERACTION` with the real intent recorded in
 * `intendedRoleActions`, exactly as `actions.contacts.ts` does for the same section. Narrowing
 * onto these codes is a separate, later change.
 */
export const ACTIONS_CANDIDATE_MEDIA = {
	CANDIDATE_MEDIA: 'candidate_media',
	CANDIDATE_MEDIA_UPLOAD: 'candidate_media_upload',
	CANDIDATE_MEDIA_DELETE: 'candidate_media_delete',
} as const;
